const PencilIcon = () => `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"
  viewBox="0 0 16 16" fill="currentColor">
<path d="M5,14.1H1.9V11l8.4-8.4l3.1,3.1L5,14.1z M3.4,12.6h0.9l6.9-6.9l-0.9-0.9l-6.9,6.9V12.6z"/>
<rect x="12.3" y="0.8" transform="matrix(0.7071 -0.7071 0.7071 0.7071 1.6863 10.0711)" width="1.5" height="4.3"/>
</svg>`;
export default PencilIcon;
